import { createTheme } from "@mui/material/styles";
export const theme = createTheme({
  breakpoints: {
    values: {
      "2xl": 1440,
      lg: 1230,
      loginChangeBackground: 1160,
      md: 900,
      sm: 600,
      xl: 1330,
      xl2: 1400,
      xs: 0,
    },
  },
  components: {
    MuiCard: {
      defaultProps: {
        onKeyDown: (event) => {
          if (event.code === "Space" || event.code === "Enter") {
            event.currentTarget.click();
          }
        },
        sx: {
          ":active": {
            background: "var(--color-selection-subtle)",
            outline: "1px solid var(--color-border-soft)",
          },
          ":focus:not(:active)": {
            outline: "var(--border-focus-thick)",
          },
          ":hover": {
            border: "var(--border-subtle)",
            boxShadow: "var(--box-shadow-up-hover)",
          },
          backgroundColor: "var(--color-surface-bright)",
          border: "1px solid transparent",
          borderRadius: "8px",
          boxShadow: "var(--box-shadow-elevation-100)",
          color: "var(--color-foreground-strong)",
          cursor: "pointer",
          outline: "1px solid transparent",
          padding: "1.6rem",
          transition: "all 0.15s ease-out",
        },
        tabIndex: 0,
      },
    },
    MuiCheckbox: {
      defaultProps: {
        sx: {
          padding: "4px 8px",
        },
      },
    },
    MuiModal: {
      defaultProps: {
        disableRestoreFocus: true,
      },
    },
    MuiPaper: {
      defaultProps: {
        elevation: 0,
        sx: {
          backgroundColor: "var(--color-surface-bright)",
          border: "var(--border-soft)",
          borderRadius: "10px",
          color: "var(--color-foreground-strong)",
          padding: "2.4rem",
        },
      },
    },
    MuiRadio: {
      defaultProps: {
        sx: {
          "&.Mui-checked": {
            color: "var(--color-element-primary-initial)",
          },
          padding: "4px 8px",
        },
      },
    },
    MuiStack: {
      defaultProps: {
        alignItems: "center",
        direction: "row",
        justifyContent: "flex-start",
        useFlexGap: true,
      },
    },
    MuiTab: {
      defaultProps: {
        disableRipple: true,
        sx: {
          "&.Mui-selected": {
            border: "none",
            color: "var(--color-foreground-inverse)",
            outline: "none",
          },
          "&:hover:not(.Mui-selected)": {
            backgroundColor: "var(--color-selection-strong)",
          },
          background: "transparent",
          borderRadius: 2,
          color: "var(--color-foreground-primary)",
          cursor: "pointer",
          display: "flex",
          fontWeight: 900,
          justifyContent: "center",
          margin: "0 4px",
          textAlign: "center",
        },
      },
    },
    MuiTableCell: {
      defaultProps: {
        sx: {
          backgroundColor: "var(--color-surface-bright)",
        },
      },
    },
    MuiTabs: {
      defaultProps: {
        centered: true,
        indicatorColor: "transparent",
        sx: {
          alignItems: "center",
          backgroundColor: "transparent",
          // borderRadius: 2,
          display: "flex",
          height: "24px",
          justifyContent: "space-between",
          padding: "4rem 0px",
        },
      },
    },

    MuiTypography: {
      defaultProps: {
        sx: {
          fontFamily: "var(--font-primary)",
          fontSize: "1.4rem",
          fontWeight: 400,
          letterSpacing: "0em",
          lineHeight: "2rem",
        },
      },
    },
  },
  spacing: (factor) => `${0.4 * factor}rem`,
});
